export default function(options) {
  var self = this;

  self.defaults = {
    offset: 1.5,
    bgY: 0,
    type: 'bg',
    transformProperty: Modernizr.prefixed('transform'),
    animationMethod: (Modernizr.csstransitions && Modernizr.csstransforms) ? 'css' : 'animate',
    animationFrame: Modernizr.prefixed('requestAnimationFrame', window) || function(callback) { window.setTimeout(callback, 1000 / 60); }
  };

  self.config = _.extend(self.defaults, options);

  self.init = function() {
    self.watchElement(self.config.$element, self.config.type);
  };

  self.watchElement = function($element, type) {
    if(type === 'bg') {
      $(window).on('scroll', { el: $element }, self.animateBg);
    } else {
      $(window).on('scroll', { el: $element }, self.animateNode);
    }
  };

  self.animateBg = function(event) {
    if (!event.data) {
      return;
    }
    var $element = event.data.el,
      bgX = $element.css('background-position-x'),
      parallaxPos = self.calcParallax(self.config.bgY, self.config.offset);

    if(Kadenze.UIUtil.isInView($element)) {
      $element.css('background-position', bgX + '% ' + parallaxPos + '%');
    }
  };

  self.animateNode = function(event) {
    // TODO: Implement animating nodes
  };

  // Utils

  self.calcParallax = function(startOffset, offset) {
    return startOffset - (window.pageYOffset / offset);
  };

  self.init();

  return self;
} /// End Kadenze.Parallaxfactory

